
import CAvatar from "@/components/CAvatar.vue";
import { PRODUCTID } from "@/utils/auth";
import UserService from "@/api/userService";
import OrderService from "@/api/orderService";
import dateFormat from 'vux/src/tools/date/format.js'


export default {
data() {
return {
off: false,
isStart: false, // 活动是否已经开始
name: "胶原蛋白弹性蛋白饮料",
pic: require("../../assets/logo.png"),
stock: "",
products: [],
};
},
computed: {
buyIcon: function () {
if (this.$root.themeType == "yellow") {
return require("../../assets/theme_yellow/buy2.png");
} else {
return require("../../assets/theme_black/buy2.png");
}
},
},
mounted() {
this.getStock();
},
methods: {
/**
* 查询我的库存接口
*/
getStock() {
UserService.queryStock(PRODUCTID)
.then((res) => {
this.pic = res.data.titlePic;
this.stock = res.data.stock;
this.name = res.data.productName;

this.queryProducts();
})
.catch((err) => {
this.$vux.toast.text(err.msg);
});
},
/**
* 获取商品兑换结果数据
*/
getExhange(targetProductId) {
let postData = {
sourceProductId: PRODUCTID,
sourceProductQuantity: this.stock,
targetProductId: targetProductId,
};
OrderService.calcExchange(postData)
.then((res) => {
this.products.forEach((ele) => {
if (ele.key == targetProductId) {
ele.convert = res.data.targetProductQuantity;
}
});
})
.catch((err) => {
this.$vux.toast.text(err.msg);
});
},
/**
* 查询商品列表
*/
queryProducts() {
OrderService.queryProducts(PRODUCTID)
.then((res) => {
this.products = [];
res.list.forEach((it) => {

let convert = 0;









this.products.push({
...it,
convert: convert,
});
this.getExhange(it.key);


if(it.key == "1647779951578025985"){
if(it.etxtractBeginTimeCountdown > 0){
this.isStart = false;
let timeDown = it.etxtractBeginTimeCountdown;
var time = setInterval(() => {
timeDown =  timeDown - 1000;

if(timeDown < 1000){
this.isStart = true;
clearInterval(time);
}
}, 1000);
} else {

this.isStart = true;
}
}
});
})
.catch((err) => {
this.$vut.toast.text(err.msg);
});
},
/**
* 点击立即提货，进入提货操作页
*/
clickDelivery(e) {
this.$router.push({
path: "/delivery",
query: {
product: JSON.stringify(e),
stock: this.stock,
},
});
},
/**
* 点击立即补货，返回robbing页
*/
clickReplenish() {
this.$router.push({
path: "/robbing",
});
},
},
filters: {
filtKeyName: function (e) {
let res = "";
if (e == "8153724996370400") {
res = "固体";
} else if (e == "8153725012044602") {
res = "液体";
} else if (e == "8155244507410000") {
res = "经典版";
} else if (e == "8156213789948654") {
res = "裸藻";
} else if (e == "8158735277245403") {
res = "日本版";
} else if (e == "8160223245934659") {
res = "家庭装";
} else if (e == "8160367516337895") {
res = "益生菌";
} else if (e == "1383959923502743554") {
res = "小蓝";
} else if (e == "1383959923502743555") {
res = "红石榴";
}
return res;
},
filtBeginTime: function (e) {
let res = e;
if (e) {
res = res.replace(/\-/g, '/');
res = dateFormat(new Date(res), "MM月DD日 HH:mm");
}
return res;
},
},
components: {
CAvatar,
},
};



// WEBPACK FOOTER //
// ./src/views/inventory/inventory.vue